// From ascii-reveal f602e204, MIT. Only the helpers needed by the selected skeleton renderer.
/** Small integer hash in [0, 1). Deterministic, so glyph flicker is stable per frame. */
export function hash(a: number, b: number, c: number): number {
  let h =
    Math.imul(a | 0, 0x27d4eb2d) ^
    Math.imul(((b | 0) + 0x9e3779b9) | 0, 0x85ebca6b) ^
    Math.imul(((c | 0) + 0x632be5ab) | 0, 0xc2b2ae35);
  h ^= h >>> 15;
  h = Math.imul(h, 0x2c1b3c6d);
  h ^= h >>> 12;
  h = Math.imul(h, 0x297a2d39);
  h ^= h >>> 15;
  return (h >>> 0) / 4294967296;
}

export const isBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';
export const reducedMotion = () =>
  isBrowser() && !!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export function freeCanvas(c: HTMLCanvasElement | null | undefined) {
  if (!c) return;
  c.width = 0;
  c.height = 0;
  c.remove();
}
